export type TCaseMatchTagColorKey = "red" | "orange" | "green" | "teal" | "lightBlue" | "blue" | "purple" | "neutral";

export type TCaseMatchTagColor = {
  key: TCaseMatchTagColorKey;
  border: string;
  bg: string;
};

export const CASE_MATCH_TAG_COLORS: TCaseMatchTagColor[] = [
  { key: "red", border: "#EF5350", bg: "#FFEBEE" },
  { key: "orange", border: "#FFA726", bg: "#FFF3E0" },
  { key: "green", border: "#66BB6A", bg: "#E8F5E9" },
  { key: "teal", border: "#26A69A", bg: "#E0F2F1" },
  { key: "lightBlue", border: "#29B6F6", bg: "#E1F5FE" },
  { key: "blue", border: "#42A5F5", bg: "#E3F2FD" },
  { key: "purple", border: "#AB47BC", bg: "#F3E5F5" },
  { key: "neutral", border: "#767B7E", bg: "#F8F9F9" },
];

export const CASE_MATCH_TAG_COLOR_MAP: Record<string, TCaseMatchTagColor> = CASE_MATCH_TAG_COLORS.reduce(
  (acc, c) => ({ ...acc, [c.key]: c }),
  {} as Record<string, TCaseMatchTagColor>,
);

export const MAX_CASE_MATCH_TAGS = 8;

export const MAX_CASE_MATCH_TAG_LABEL_LENGTH = 10;
